import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { api } from '@/lib/api';
import type { Page } from '@hellenica/shared';

export default function PageList() {
  const { data, isLoading } = useQuery<{ pages: Page[] }>({
    queryKey: ['pages'],
    queryFn: () => api.get('/v1/admin/pages'),
  });

  if (isLoading) return <div className="animate-pulse">Loading...</div>;

  return (
    <div>
      <h1 className="text-2xl font-semibold text-gray-900 mb-8">Pages</h1>
      <div className="bg-white shadow rounded-lg divide-y">
        {data?.pages.map((page) => (
          <Link key={page.id} to={`/pages/${page.id}`} className="block p-6 hover:bg-gray-50">
            <h3 className="text-lg font-medium text-gray-900">{page.title}</h3>
            <p className="text-sm text-gray-500">/{page.slug}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
